import { isIOS } from "../utils/is-mobile";
import { MediaDevices, MediaDevicesEvents } from "../utils/media-devices-utils";
import { PermissionStatus } from "../utils/media-devices-utils";

export default class MediaDeviceManagerPermissions {
  constructor(deviceManager) {
    this.deviceManager = deviceManager;
    this.setupCameraPermissionListener();
  }

  async fetchVideoDevices() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: isIOS() ? { max: 1280 } : { max: 1280, ideal: 720 }
        }
      });

      await this.deviceManager.fetchVideoDevices();
      if (this.deviceManager?.videoDevicesOptions?.length > 0) {
        this.deviceManager.setDeviceId(this.deviceManager.videoDevicesOptions[0].value);
      }

      // Stop the video stream to release the camera
      stream.getTracks().forEach(track => track.stop());
    } catch (e) {
      console.error(e);
      // this.deviceManager.emit(MediaDevicesEvents.PERMISSIONS_STATUS_CHANGED, {
      //   mediaDevice: MediaDevices.CAMERA,
      //   status: PermissionStatus.DENIED
      // });
    }
  }

  setupCameraPermissionListener() {
    if (navigator.permissions) {
      // Query the camera permission and set up the onchange listener
      navigator.permissions
        .query({ name: "camera" })
        .then(permissionStatus => {
          // Emit the permission status change on first run
          this.deviceManager.emit(MediaDevicesEvents.PERMISSIONS_STATUS_CHANGED, {
            mediaDevice: MediaDevices.CAMERA,
            status: permissionStatus.state
          });

          // Listen for changes to the camera permission state
          permissionStatus.onchange = async () => {
            this.deviceManager.emit(MediaDevicesEvents.PERMISSIONS_STATUS_CHANGED, {
              mediaDevice: MediaDevices.CAMERA,
              status: permissionStatus.state
            });

            if (permissionStatus.state === PermissionStatus.GRANTED) {
              const emit = false;
              await this.deviceManager.fetchVideoDevices(emit);
              if (this.deviceManager?.videoDevicesOptions?.length > 0) {
                this.deviceManager.setDeviceId(this.deviceManager.videoDevicesOptions[0].value);
              }
              this.deviceManager.emit(MediaDevicesEvents.VIDEO_DEVICES_CHANGED);
            }
          };
        })
        .catch(err => {
          console.error("Error querying camera permissions:", err);
        });
    }
  }

  setupMicListener() {
    if (navigator.permissions) {
      navigator.permissions
        .query({ name: "microphone" })
        .then(permissionStatus => {
          // Listen for changes to the microphone permission state
          permissionStatus.onchange = async () => {
            if (permissionStatus.state === PermissionStatus.GRANTED) {
              await this.deviceManager.fetchMediaDevices();
            }

            this.deviceManager.emit(MediaDevicesEvents.PERMISSIONS_STATUS_CHANGED, {
              mediaDevice: MediaDevices.MICROPHONE,
              status: permissionStatus.state
            });
          };
        })
        .catch(err => {
          console.error("Error querying microphone permissions:", err);
        });
    }
  }
}
